export const isAuthenticated = (state) => {
	if (!!state?.auth?.auth?.user?.id) return true;
	return false;
};
